/**
 * 安全管理模块
 */
 import axios from '../request';
 export default{
  /**
   * 安全公告模块
   */
  // 查询安全公告信息列表
  searchSafetyAfficheList: (params) =>
    axios({
      method: 'post',
      url: '/secure/secureNotice/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        noticeName: params.noticeName,
        startTime: params.startTime,
        endTime: params.endTime
      }
    }),
  // 添加 修改 安全公告信息
  insertSafetyAfficheInfo: (params) =>
    axios.post('/secure/secureNotice/addSecureNotice', params),
  // 删除安全公告信息
  deleteSafetyAfficheInfo: (params) =>
    axios.post('secure/secureNotice/delete', params),
  // 上架 下架安全公告信息
  upAndDownSafetyAfficheInfo: (params) =>
    axios.post('/secure/secureNotice/updown', params),


  /**
   * 劳务档案
   */
  //奖惩记录列表
	recordAwardsLists: (params) =>
    axios.post('/secure/encourage/encourageRecordWebList', params),
  //安全码列表
  codeSafeLists: (params) =>
    axios.post('/secure/encourage/encourageSecurityCode', params),

  /**
   * 安全考核模块
  */
  // 根据类型获取类型名称(安全培训和日常培训制定名称)
  getAllSecureTrainPull: (params) =>
    axios.post('/secure/secureTrain/secureTrainPull', params),
  // 查询安全考核信息
  searchSafetyExamineList: (params) =>
    axios({
      method: 'post',
      url: '/secure/exam/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        examName: params.examName,
        startDay: params.startDay,
        endDay: params.endDay
      }
    }),
  // 添加 修改 安全考核信息
  insertSafetyExamineInfo: (params) =>
    axios.post('/secure/exam/addExam', params),
  // 删除安全考核信息
  deleteSafetyExamineInfo: (params) =>
    axios.post('/secure/exam/delete', params),
  // 获取安全考核统计信息
  getExamRecordStatistical: (params) =>
    axios.post('/secure/examRecord/recordStat', params),
  // 查询安全考核记录
  searchSafetyCheckRecord: (params) =>
    axios({
      method: 'post',
      url: '/secure/examRecord/recordList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        examId: params.examId,
        examResult: params.examResult,
        departId: params.departId,
        groupId: params.groupId,
        startTime: params.startTime,
        endTime: params.endTime
      }
    }),
  
  
  // 安全考题信息列表
  searchSafetyTopicList: (params) =>
  axios({
    method: 'post',
    url: '/secure/question/findList',
    headers: {
      pageNum: params.pageNum,
      pageSize: params.pageSize
    },
    data: {
      trainName: params.trainName
    }
  }),
  // 新增 修改安全考题信息
  insertSafetyTopicInfo: (params) =>
    axios.post('/secure/question/addQuestion', params),
  // 删除安全考题信息
  deleteSafetyTopicInfo: (params) =>
    axios.post('/secure/question/delete', params),
  // 获取答案列表信息
  getAnswerlIstInfo: (params) =>
    axios.post('secure/question/answerList', params),

  /**
   * 消防器材模块
   */
  // 查询消防器材信息列表
  searchFireequipmentList: (params) =>
    axios({
      method: 'post',
      url: '/secure/secureGood/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        goodName: params.goodName,
        startTime: params.startTime,
        endTime: params.endTime
      }
    }),
  // 添加 修改 消防器材信息
  insertFireequipmentInfo: (params) =>
    axios.post('/secure/secureGood/addSecureGood', params),
  // 删除消防器材信息
  deleteFireequipmentInfo: (params) =>
    axios.post('secure/secureGood/delete', params),
  // 导出二维码
  getFireequipmentCode: (params) =>
    axios({
      method: 'get',
      url: '/secure/secureGood/viewcode',
      params: params,
      responseType: 'blob'
    }),
  // 获取消防器材图片列表
  getFireequipmentImageInfo: (params) =>
    axios.post('/secure/secureGood/fileList', params),
  // 消防器材导出
  exportFireequipmentfile: (params) =>
    axios({
      method: 'post',
      data: params,
      url: '/secure/secureGood/recordExport',
      responseType: 'blob'
    }),


  /**
   * 安全培训和日常培训制定
   */
  // 列表信息
  searchEnactLists: params =>
    axios.post('/secure/secureTrain/secureTrainList', params),
  // 添加信息
  insertEnactInfo: params =>
    axios.post('/secure/secureTrain/secureTrainInsert', params),
  // 修改信息
  updateEnactInfo: params =>
    axios.post('/secure/secureTrain/secureTrainUpdate', params),
  // 信息详情
  detailsEnactInfo: params =>
    axios.post('/secure/secureTrain/secureTrainInfo', params),
  // 删除信息
  deleteEnactInfo: params =>
    axios.post('/secure/secureTrain/secureTrainDel', params),
  //查询记录
  getEnactRecords: params =>
    axios.post('/secure/secureTrain/secureTrainRecord', params),

  /**
   * 安全资料模块
   */
  // 列表信息
  searchDatumLists: params =>
    axios.post('/secure/material/materialList', params),
  // 添加信息
  insertDatumInfo: params =>
    axios.post('/secure/material/materialInsert', params),
  // 修改信息
  updateDatumInfo: params =>
    axios.post('/secure/material/materialUpdate', params),
    // 信息详情
  detailsDatumInfo: params =>
    axios.post('/secure/material/materialInfo', params),
  
  /**
   * 奖惩标准模块
   */
  // 列表信息
  searchPunishLists: params =>
    axios.post('/secure/encourage/encourageList', params),
  // 添加信息
  insertPunishInfo: params =>
    axios.post('/secure/encourage/encourageInsert', params),
  // 修改信息
  updatePunishInfo: params =>
    axios.post('/secure/encourage/encourageUpdate', params),
  // 信息详情
  detailsPunishInfo: params =>
    axios.post('/secure/encourage/encourageInfo', params),
  // 信息删除
  deletePunishInfo: params =>
    axios.post('/secure/encourage/encourageDel', params),
}